import { render } from "./Lesson.vue?vue&type=template&id=5e5cdca3&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"

import "./Lesson.vue?vue&type=style&index=0&id=5e5cdca3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e5cdca3"

export default script